function markEmptyAccordions() {
  document.querySelectorAll('accordion-custom[data-hide-if-empty="true"]').forEach((acc) => {
    const content = acc.querySelector('.details-content');
    if (!content) return;

    // Grab visible text (ignores most HTML whitespace)
    const text = content.textContent.replace(/\s+/g, '').trim();

    // Check for media too (image/video/iframe), in case the accordion is visual-only
    const hasMedia = content.querySelector('img, video, iframe, svg');

    if (!text && !hasMedia) {
      acc.classList.add('is-empty');
    } else {
      acc.classList.remove('is-empty');
    }
  });
}

// Run on initial load
document.addEventListener('DOMContentLoaded', markEmptyAccordions);

// Run again after Shopify section re-renders in the theme editor
document.addEventListener('shopify:section:load', markEmptyAccordions);
document.addEventListener('shopify:block:select', markEmptyAccordions);
document.addEventListener('shopify:block:deselect', markEmptyAccordions);